(function($) {

	// for the sections/collection-list-random.liquid
	// make sure the number of collections does not exceed the limit
	// by removing random collections over the limit

	function filterCollectionList() {
		$('.list-collections[data-limit]').each(function() {
			var $collectionList = $(this);
			var limit = parseInt($collectionList.data('limit'), 10);

			if (!limit) return;

			// remove random elements until only `limit` remain
			while ($collectionList.find('.random-collection-product').length > limit) {
				var $items = $collectionList.find('.random-collection-product');
				var randomIndex = Math.floor(Math.random() * $items.length);
				$items.eq(randomIndex).remove();
			}
		});
	}

	$(function() {
		filterCollectionList();
	});

})(jQuery)
